<template>
    <div class="login-wrap">
        <div class="top">
            <img src="../../assets/img/logo.png" class="logo" @click="openPage('/home')" />
            <div class="header-user-con">
                <div class="el-link" style="margin-left: 5px;margin-right: 5px;" @click="openPage('/home')">首页</div>
                <div class="el-lable" style="margin-left: 5px;margin-right: 5px;">|</div>
                <div class="el-link" style="margin-left: 5px;margin-right: 5px;" @click="openPage('/help')">帮助中心</div>
            </div>
        </div>

        <div style="width: 100%;display: flex;">
            <div style="width: 45%;height: 100%;">
                <img src="../../assets/img/phone.png" class="phone" />
            </div>

            <div style="width: 55%;height: 100%;">
                <div style="display: flex;margin-top: 100px;">
                    <img src="../../assets/img/icon.png" class="icon" />
                    <div style="width: 100%;">
                        <div class="title1">1701账号服务App</div>
                        <div class="title2">安全、权威、服务完善的大型网络游戏账号交易平台</div>
                    </div>
                </div>
                <img src="../../assets/img/downloadcode.png" class="code" />
                <div class="downloadtips">手机扫码下载App</div>
            </div>
        </div>









        <div class="bottom">
            <span class="footertitle">备案号：浙ICP备2024099507号-1</span>
            <span class="footertitle"> 杭州奕游网络科技有限公司版权所有</span>
        </div>

    </div>
</template>

<script>

export default {
    data: function () {
        return {

        }
    },
    created() {

    },
    computed: {
    },
    methods: {
        openPage(url) {
            this.$router.push(url);
        },
    }
}

</script>

<style scoped>
.login-wrap {
    position: relative;
    width: 100%;
    height: 100%;
    background: linear-gradient(#fffbf8, #ffddca);
    background-size: 100%;
   
}


.top {
    height: 80px;
    background-color: #ffffff;
}

.bottom {
    position: absolute;
    height: 60px;
    width: 100%;
    bottom: 0;
    background-color: #ffffff;
    text-align: center;
    padding-top: 10px;

}

.footertitle {
    color: rgb(85, 85, 85);
    text-align: center;
    line-height: 30px;
    padding-top: 60px;
}

.ms-content {
    padding: 20px 20px;
}


.logo {
    width: 260px;
    height: 60px;
    margin-left: 100px;
    margin-top: 10px;
    cursor: pointer;
}

.header-user-con {
    display: flex;
    height: 40px;
    align-items: center;
    float: right;
    margin-right: 50px;
    margin-top: 10px;
}

.phone {
    width: 600px;
    height: 600px;
    margin-left: calc(50% - 200px);
    margin-top: 20px;

}

.code {
    width: 200px;
    height: 200px;
    margin-left: 30px;
    margin-top: 60px;
}

.title1 {
    padding-left: 20px;
    color: rgb(42, 42, 42);
    font-size: 24px;
    margin-top: 20px;
  
}

.title2 {
    padding-left: 20px;
    color: rgb(94, 94, 94);
    font-size: 18px;
    margin-top: 10px;
}

.icon {
    width: 100px;
    height: 100px;
    border-radius: 16px;
    box-shadow: 4px 4px 20px rgba(161, 161, 161, 0.3);
}

.downloadtips
{
    margin-top: 10px;
    margin-left: 30px;
    width: 200px;
    text-align: center;
}
</style>